@if (collection) {
  <div class="container-fluid admin-form-page">
    <div class="row section1">
      <div class="col-12 col-md-7 col-lg-4 col-xl-4">
        <div class="home-details">
          <h5 class="home-title">Collection Details</h5>
        </div>
      </div>
      <div class="col-12 col-md-7 col-lg-5 col-xl-5">
        <div class="dashboard-btn dashboard-manage admin-page-actions">
          <button type="button" class="btn btn-primary btn-dashboard" (click)="_location.back()">Back</button>
          <!--        <div><a [routerLink]="['/users/edit-details/', collection.id]">-->
          <!--          <button class="btn btn-primary btn-deshboard">Edit-->
          <!--            Details-->
        <!--          </button>-->
      <!--        </a></div>-->
      <!--        <div class="cog-icn"><a><i class="las la-redo-alt"></i></a></div>-->
      <!--        <div class="cog-icn"><a><i class="las la-times"></i></a></div>-->
    </div>
  </div>
</div>
<div class="row section1">
  <div class="col-12 ">
    <div class="applicants-details details1 admin-form-card pt-4">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
          <p>Collection Id</p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          <p>{{collection.id}}</p>
        </div>
      </div>
      <hr class="border2">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
          <p>Collection Title</p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          <p>{{collection.title}}</p>
        </div>
      </div>
      <hr class="border2">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
          <p>Description</p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          <p>{{collection.description}}</p>
        </div>
      </div>
      <hr class="border2">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
          <p>Thumbnail</p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          <img src="{{collection.thumbnail}}" class="img-fluid mb-2" alt="" width="100">
        </div>
      </div>
      <hr class="border2">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user">
          <p>NFTs</p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          @for (item of collection.items; track item) {
            <div>
              <img src="{{item.image}}" alt="nft" width="100" class="m-2">
              <span [ngClass]="item.status ? 'text-danger' : 'text-success'" class="btn" (click)="toggleNFT(item.id)">{{item.status ? 'Disable' : 'Enable'}}</span>
            </div>
          }
        </div>
      </div>
      <hr class="border2">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
          <p>Created on</p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          <p>{{collection.createdAt | date}}</p>
        </div>
      </div>
      <hr class="border2">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
          <p>Last updated at</p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          <p>{{collection.updatedAt | date}}</p>
        </div>
      </div>
      <hr class="border2">
    </div>
  </div>
  <div class="col-12 col-md-4">
    <div class="applicants-details details1 admin-form-card">
      <form class="admin-form" (ngSubmit)="addNFT()" ngNativeValidate>
        @if (!addMode) {
          <button type="button" class="btn btn-primary btn-dashboard" (click)="addMode = true">Add NFT</button>
        }
        @if (addMode) {
          <div class="row">
            <div class="col-12">
              <div class="user-form">
                <div class="form-group">
                  <label for="collectionName">Title*</label>
                  <input required [(ngModel)]="addData.title" name="title" class="form-control"
                    type="text" id="collectionName" placeholder="Enter NFT title">
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="user-form">
                <div class="form-group">
                  <label for="collectionThumbnail">Image*</label>
                  @if (uploaded) {
                    <img src="{{addData.image}}" width="200" class="mb-2" alt="">
                  }
                  @if (!uploaded) {
                    <input class="form-control" (change)="uploadImage($event)" name="thumbnail"
                      id="collectionThumbnail" type="file" required/>
                  }
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="user-form">
                <div class="form-group">
                  <label for="collectionURL">URL*</label>
                  <input required [(ngModel)]="addData.url" name="url" class="form-control" type="url"
                    id="collectionURL" placeholder="Enter NFT URL">
                </div>
              </div>
            </div>
            <div class="col-12">
              <button class="btn btn-primary btn-dashboard" type="submit">Save NFT</button>
            </div>
          </div>
        }
      </form>
    </div>
  </div>
</div>
</div>
}
